import { Spin } from 'antd';
import { Building } from 'iconsax-react';
import { useWorkspaceSyncGuard } from '@hooks/useWorkspaceSyncGuard';

/**
 * Overlay that blocks all interaction when workspace context is being synced
 * due to a change in another browser tab.
 *
 * This prevents users from accidentally operating on the wrong workspace
 * when the cookie-based context changes in another tab.
 */
const WorkspaceSyncOverlay = () => {
  const { isSyncing, newWorkspaceName } = useWorkspaceSyncGuard();

  if (!isSyncing) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(4px)',
      }}
      // Prevent any clicks from reaching elements below
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md mx-4 text-center">
        <div className="flex justify-center mb-4">
          <div className="relative">
            <Building size={48} variant="Bulk" color="var(--color-primary)" />
            <div className="absolute -right-1 -bottom-1 bg-primary rounded-full p-1">
              <Spin size="small" />
            </div>
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Syncing Workspace Context
        </h2>

        <p className="text-gray-600 mb-4">
          Another tab switched to{' '}
          <span className="font-medium text-primary">{newWorkspaceName}</span>.
          <br />
          Updating your session to stay in sync...
        </p>

        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <Spin size="small" />
          <span>This only takes a moment</span>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceSyncOverlay;
